import script from "./cascade-lower-branches-block.vue?vue&type=script&setup=true&lang=ts"
export * from "./cascade-lower-branches-block.vue?vue&type=script&setup=true&lang=ts"

import "./cascade-lower-branches-block.vue?vue&type=style&index=0&id=cc00c672&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc00c672"]])

export default __exports__